export default "__VITE_ASSET__F0zsbAis__"